export enum BookType {
  ORDERBOOK = "orderBook",
  TRADEBOOK = "tradeBook",
  POSITIONSBOOK = "positionsBook"
}


export enum StrategyType {
  FORWARD = "Forward",
  LIVE = "Live"
}
